import Marquee from "react-fast-marquee";

const ITEMS = [
  "Custom Cakes",
  "Weddings",
  "Birthdays",
  "Kids Birthdays",
  "Themed Cakes",
  "Cupcakes",
  "Cookies",
  "Hillcrest / Logan",
];

export default function Ribbon() {
  return (
    <div className="relative z-10 border-y border-gold/30 bg-white/60 py-5 backdrop-blur-sm" data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false} aria-hidden>
        {ITEMS.map((item) => (
          <span key={item} className="mx-12 flex items-center gap-24 font-serif text-xl sm:text-2xl italic text-burgundy/70">
            {item}
            <span className="ml-24 inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
